import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductSocialShareComponent } from '../../social-share/product-social-share.component';

@Component({
    selector: 'product-view-share',
    templateUrl: './product-view-share.component.html',
    standalone: true,
    imports: [ProductSocialShareComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewShareComponent extends UiComponent {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;
}
